/* eslint-disable react/no-multi-comp */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import {
	Button,
	Card,
	CardContent,
	CardHeader,
	Divider,
	IconButton,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Radio,
	Tooltip,
	Typography,
	colors,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ArchiveIcon from '@mui/icons-material/ArchiveOutlined';

import axios from 'utils/axios';
import { Label } from 'components';

const getLabel = (todo) => {
	if (todo.done) {
		return null;
	}

	if (moment(todo.deadline).isBefore(moment(), 'day')) {
		return (
			<Label color={colors.red[600]}>
				{`Due ${moment(
					todo.deadline
				).fromNow()}`}
			</Label>
		);
	}

	if (moment(todo.deadline).isSame(moment(), 'day')) {
		return <Label color={colors.orange[600]}>Due today</Label>;
	}

	return <Label>{`Due ${moment(todo.deadline).fromNow()}`}</Label>;
};

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	addIcon: {
		marginRight: theme.spacing(1),
	},
	done: {
		textDecoration: 'line-through',
		color: theme.palette.text.secondary,
	},
}));

const Todos = (props) => {
	const { className, ...rest } = props;

	const classes = useStyles();
	const [todos, setTodos] = useState([]);

	useEffect(() => {
		let mounted = true;

		const fetchTodos = () => {
			axios.get('/api/account/todos').then((response) => {
				if (mounted) {
					setTodos(response.data.todos);
				}
			});
		};

		fetchTodos();

		return () => {
			mounted = false;
		};
	}, []);

	const handleChange = (event, todo) => {
		setTodos((items) => items.map((t) => {
			if (t.id === todo.id) {
				return { ...todo, done: !todo.done };
			}

			return t;
		})
		);
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardHeader
				action={(
					<Button color="primary" size="small">
						<AddIcon className={classes.addIcon} />
						Add
					</Button>
				)}
				title="My todos"
			/>
			<Divider />
			<CardContent className={classes.content}>
				<List>
					{todos.map((todo, i) => (
						<ListItem divider={i < todos.length - 1} key={todo.id}>
							<ListItemIcon>
								<Radio
									checked={todo.done}
									onClick={(event) => handleChange(event, todo)}
								/>
							</ListItemIcon>
							<ListItemText>
								<Typography
									className={clsx({
										[classes.done]: todo.done,
									})}
									variant="body1"
								>
									{todo.title}
								</Typography>
							</ListItemText>
							{getLabel(todo)}
							<Tooltip title="Archive">
								<IconButton size="large">
									<ArchiveIcon />
								</IconButton>
							</Tooltip>
						</ListItem>
					))}
				</List>
			</CardContent>
		</Card>
	);
};

Todos.propTypes = {
	className: PropTypes.string,
};

export default Todos;
